import { EMPTY_FILTERS, NoticeFilters } from "components/notices/utils";
import { BuyerTableFilters } from "./types";

export function convertBuyerFiltersToNoticeFilters(
  buyerFilters: BuyerTableFilters,
  buyerGuid: string,
): NoticeFilters {
  // Buyer filters are not used as this conversion is used to access the notice table on the filters page where the buyer is hardcoded
  const noticeFilter: NoticeFilters = {
    ...EMPTY_FILTERS,
    buyers: [buyerGuid],
    supplierGuids: buyerFilters.supplierGuids || [],
    supplierSme: buyerFilters.supplierSme || "",
  };
  return noticeFilter;
}
